import styled from "styled-components"
import { Colors } from 'styles/app-styles'

export const Dashboard_s = styled.div`
  padding: 20px;
`

export const LearningCenter_s = styled.div`
  border: 1px solid ${Colors.towerGrey};
  margin-top: 40px;
  padding: 10px;
  > details > summary {
    background: ${Colors.inputFocus};
    color: ${Colors.darkDenim};
    cursor: pointer;
    margin-left: 5px;
    outline:none;
    padding: 5px;
  }
  > details > div {
    display: grid;
    font-size: 14px;
    grid-gap: 15px;
    grid-template-columns: 33% auto 33%;
    grid-template-rows: 200px;
    margin: 15px 5px 5px 5px;
    > div, > div > a {
      align-items: center;
      color: ${Colors.blackPearl};
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    > div {
      background: ${Colors.inputFocus};
      border: 1px solid ${Colors.towerGrey};
      color: ${Colors.blackPearl};
      cursor: pointer;
      > a {
        height: 100%;
        width: 100%;
        span:nth-child(2) {
          color: ${Colors.blackPearl};
        }
        svg {
          fill: ${Colors.denim};
        }
      }
      &:hover {
        background: ${Colors.lightMystic};
      }
      > *, > a > * {
        margin-bottom: 10px;
      }
    }
`

interface DashboardWidgetProps {
  expanded: boolean
}

export const DashboardWidgetsContainer_s = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 180px);
  justify-content: space-between;
  width: 100%;
`

export const DashboardWidget_s = styled.div<DashboardWidgetProps>`
  border: 1px solid ${Colors.towerGrey};
  height: calc(50% - 20px);
  margin-top: 20px;
  padding: 10px 15px 0 15px;
  width: ${props => props.expanded ? '100%' : 'calc(50% - 10px)'};
  table { width: 100%; }
`

export const WidgetHeader_s = styled.div`
  border-bottom: 1px solid ${Colors.towerGrey};
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 5px;
`

export const WidgetBody_s = styled.div`
  height: calc(100% - 50px);
  overflow-x: scroll;
  overflow-y: auto;
  white-space: nowrap;
  width: 100%;
`

export const SimpleTable_s = styled.table`
  // Border-collapse removes spacing between cells that is inherit with tables in css
  border-collapse: collapse; 
  color: ${Colors.blackPearl};
  font-family: 'Roboto-Light', sans-serif;
  font-size: 14px;
  thead {
    border-bottom: 1px solid ${Colors.towerGrey};
    color: ${Colors.darkDenim};
    height: 30px;
    text-align: left;
    tr { border-bottom: 2px solid ${Colors.towerGrey}; }
    th { font-weight: 400; }
  }
  > tbody > tr:nth-of-type(odd){ background-color: #F8FAFC; }
  tr {
    height: 30px;
    &:hover { background-color: ${Colors.heatherGrey} !important; }
  }
  td, th {
    border-bottom: 1px solid ${Colors.towerGrey} !important;
    padding: 0 8px;
  }
  a {
    color: ${Colors.blackPearl};
    cursor: pointer;
    font-weight: 400;
  }
  svg .r-svg { fill: ${Colors.blackPearl}; }
  .created-column {
    min-width: 150px;
  }
  .icon-column {
    height: 30px;
    text-align: center;
    width: 50px;
    > div { 
      display: flex; 
      svg:first-child { margin-right: 4px; }
    }
  }
`
